import Feature33 from './Feature33'
export default Feature33
